import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "o-grid o-grid--align-middle u-mar-t-2"
}
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--9-480 o-grid__cell--8-768 o-grid__cell--7-1024 o-grid__cell--6-1200 u-form-grid-nospace-y" }
const _hoisted_3 = { class: "o-grid" }
const _hoisted_4 = {
  class: "o-grid__cell o-grid__cell--3-1024 o-grid__cell--3-480",
  style: {"margin-right":"0"}
}
const _hoisted_5 = { class: "o-grid o-grid--no-y-gutter o-grid--align-flex-end" }
const _hoisted_6 = { class: "o-grid__cell o-grid__cell--12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!

  return (_ctx.berechneMaxRabatt(_ctx.piniaStore.state) > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "o-grid__cell o-grid__cell--12 o-grid__cell--3-480 u-text-align-right--480 u-form-grid-nospace-y" }, [
          _createElementVNode("h2", { class: "u-form-heading unset-text-align" }, "Maklerrabatt")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                onKeydown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.erzwingeGanzzahl && _ctx.erzwingeGanzzahl(...args))),
                id: "abschlagZuschlagHoehe",
                name: "abschlagZuschlagHoehe",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.piniaStore.state.tarifinformationen.abschlagZuschlagHoehe) = $event)),
                class: "c-form-control__input",
                min: "0",
                max: "99",
                placeholder: "%",
                required: "",
                "aria-required": "true",
                "aria-label": "Höhe des Maklerrabatts",
                "data-cy": "abschlagZuschlagHoehe"
              }, null, 544), [
                [
                  _vModelText,
                  _ctx.piniaStore.state.tarifinformationen.abschlagZuschlagHoehe,
                  void 0,
                  {
                    lazy: true,
                    trim: true,
                    number: true
                  }
                ]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_validierungs_fehler, {
                "fehler-text": _ctx.fehler.abschlagZuschlagHoehe
              }, null, 8, ["fehler-text"])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}